"use strict";
/** Προεπιλεγμένη ροή δημιουργίας προσφοράς (συγχρονίζεται στον λογαριασμό). */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_OFFER_FLOW_OPTIONS = exports.DEFAULT_OFFER_FLOW_MODE = exports.DEFAULT_OFFER_FLOW_MODES = void 0;
exports.isDefaultOfferFlowMode = isDefaultOfferFlowMode;
exports.defaultOfferFlowToDb = defaultOfferFlowToDb;
exports.defaultOfferFlowFromDb = defaultOfferFlowFromDb;
exports.defaultOfferCreatePath = defaultOfferCreatePath;
exports.DEFAULT_OFFER_FLOW_MODES = ['capture', 'advanced'];
exports.DEFAULT_OFFER_FLOW_MODE = 'capture';
function isDefaultOfferFlowMode(value) {
    return exports.DEFAULT_OFFER_FLOW_MODES.includes(value);
}
function defaultOfferFlowToDb(mode) {
    return mode === 'advanced' ? 'ADVANCED' : 'CAPTURE';
}
function defaultOfferFlowFromDb(mode) {
    return mode === 'ADVANCED' ? 'advanced' : 'capture';
}
function defaultOfferCreatePath(mode) {
    return mode === 'advanced' ? '/offers/new' : '/offers/capture';
}
exports.DEFAULT_OFFER_FLOW_OPTIONS = [
    {
        value: 'capture',
        label: 'Γρήγορη προσφορά',
        description: 'Τρία βήματα: σημειώσεις, πελάτης, AI.',
    },
    {
        value: 'advanced',
        label: 'Προχωρημένη',
        description: 'Πλήρης φόρμα με τίτλο, ποσό και επεξεργασία κειμένου.',
    },
];
